"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MyHomeSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="m17.2 2.47 10.09 9.5A2 2 0 0 1 28 13.5V28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V13.5a2 2 0 0 1 .71-1.53l10.09-9.5a2 2 0 0 1 2.4 0zm-4.043 8.716A4 4 0 0 1 16 10a4 4 0 0 1 3.96 4.04v.817a5.6 5.6 0 0 1-1.714 3.88l1.183.229c2.714.64 4.571 2.011 4.571 3.605v2.286c0 .631-.512 1.143-1.143 1.143H9.143A1.143 1.143 0 0 1 8 24.857v-2.286c0-1.594 1.834-2.965 4.571-3.605l1.143-.252A5.531 5.531 0 0 1 12 14.857v-.817a4 4 0 0 1 1.157-2.854z" clip-rule="evenodd" stroke="none"></path>';
var MyHomeSVG = function MyHomeSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MyHomeSVG = MyHomeSVG;
MyHomeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MyHomeSVG);
exports.default = _default;